import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-increase_icon1",
  "use": "icon-increase_icon1-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-increase_icon1\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h14v14H0z\" /><path d=\"M7 1c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6Zm0 1.2C4.36 2.2 2.2 4.36 2.2 7c0 2.64 2.16 4.8 4.8 4.8 2.64 0 4.8-2.16 4.8-4.8 0-2.64-2.16-4.8-4.8-4.8ZM6.94 4l2.94 2.94-2.94 2.94L4 6.94 6.94 4Zm0 1.74L5.68 7l1.26 1.26L8.2 7 6.94 5.74Z\" fill=\"#3D7BD8\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol